import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaMinExclusiveFacet extends XmlSchemaFacet {}
